import React from "react";
import { Offcanvas } from "react-bootstrap";
import "../RewardListCanvas/RewardListCanvas.scss";
import { RewardItem } from "../RewardList";

const RewardListCanvas = ({ isOpen, rewards, toggleCanvas, currencyView }) => {
  return (
    <Offcanvas
      show={isOpen}
      name="bottom"
      backdrop={false}
      placement="bottom"
      onHide={toggleCanvas}
      className="rewardlist-canvas"
    >
      <Offcanvas.Body className="rewardlist-offcanvas-body">
        <div className="reward-list-canvas-header">
          <span onClick={toggleCanvas}>
            <img src="/assets/icons/arrow-left.svg" alt="back" />
            Back
          </span>
        </div>
        <div className="rewardlist-canvas-body">
          <div className="rewardlist-container">
            <p>Redeem on your next purchase</p>
            {rewards?.map((reward) => (
              <RewardItem
                isTerms={true}
                reward={reward}
                key={reward?._id}
                currencyView={currencyView}
              />
            ))}
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default RewardListCanvas;
